import type { AsyncDataOptions } from '#app'
import { AsyncDataKeys, getAsyncDataKey } from '@/constants/async-data-keys'

import { getBranchArrivalTimes } from '@/service/branch'
import type { BranchArrivalTimeInfo, BranchData } from '@/types/api'

interface UseGetBranchArrivalTimesOpts {
  branch: ReadonlyRef<Nullable<BranchData>>
  attendance: ReadonlyRef<number>
  callback?: (data: BranchArrivalTimeInfo) => void
  asyncDataOpts?: AsyncDataOptions<BranchArrivalTimeInfo>
}

export async function useGetBranchArrivalTimes(prefixKey: string, { branch, attendance, callback, asyncDataOpts }: UseGetBranchArrivalTimesOpts) {
  const route = useRoute()

  const branchId = computed(() => route.params.bid as string)
  const productId = computed(() => branch.value?.pid)

  const asyncData = await useAsyncData(
    getAsyncDataKey(AsyncDataKeys.BRANCH_ARRIVAL_TIMES, [prefixKey, branchId.value, productId.value, attendance.value]),
    async () => {
      if (!branchId.value) {
        throw new Error('branchId is required')
      }
      const queryParams = { pid: productId.value, headcount: attendance.value }
      const { data } = await getBranchArrivalTimes(branchId.value, queryParams)

      if (typeof callback === 'function') {
        callback(data)
      }

      return data
    },
    asyncDataOpts
  )

  const isBranchArrivalTimesLoading = computed(() => asyncData.status.value === 'pending')

  return { ...asyncData, isBranchArrivalTimesLoading }
}
